import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  block: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 8,
  },
});
